
















































































import Vue, { PropType } from 'vue';

import {
  Brand,
  Booth,
  Item,
  Exhibitor,
//  story,
} from 'mostra';

export default Vue.extend({
  name: 'brand-edit',
  props: {
    isNew: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brand: {
      type: Object as PropType<Brand>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      default: () => ([]),
    },
    booths: {
      type: Array as PropType<Booth[]>,
      default: () => ([]),
    },
    exhibitors: {
      type: Array as PropType<Exhibitor[]>,
      default: () => ([]),
    },
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
    targetPageName: {
      type: String as PropType<string>,
      default: 'exhibitor-brand-edit',
    },
  },
  computed: {
    footerButtonText(): string {
      return '保存';
    },
    buttons(): any[] {
      return [
        {
          theme: 'primary',
          text: '保存',
          onClick: this.toUpdateData,
          withValidation: true,
        },
      ];
    },
    headingTexts(): any[] {
      if (this.isNew) {
        return [
          { text: 'ブランドページ新規作成' },
        ];
      } else {
        return [
          { text: 'ブランドページ編集' },
        ];
      }
    },
    tabLinks(): any[] {
      const q = this.$route.query;
      const ls: any[] = [
        {
          value: 0,
          text: '基本設定',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'settings',
            },
          },
          validationId: 'g-brand-setting-form',
        },
        {
          value: 1,
          text: 'デザイン設定',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'design',
            },
          },
          validationId: 'g-brand-design-form',
        },
        {
          value: 2,
          text: 'ストーリー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'story',
            },
          },
          validationId: 'g-brand-story-form',
        },
        {
          value: 3,
          text: 'SNS',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'sns',
            },
          },
          validationId: 'g-brand-sns-form',
        },
      ];
      if (!this.isNew) {
        ls.unshift({
          value: 7,
          text: 'プレビュー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'preview',
            },
          },
        });
        ls.push({
          value: 4,
          text: '取引条件',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'order',
            },
          },
          validationId: 'g-brand-order-form',
        });
        ls.push({
          value: 5,
          text: '商品掲載',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'item',
            },
          },
        });
        ls.push({
          value: 6,
          text: 'ブース',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'booth',
            },
          },
        });
      }

      return ls;
    },
  },
  methods: {
    toUpdateData() {
      this.$emit('toUpdateData');
    },
  },
});
